import { FC, useState } from 'react'

import WiseLogo from 'src/Assets/Svg/payment-systems/wise.svg?react'
import { PrimarySelect } from 'src/Components/PrimarySelect'
import { useRecipientQuery } from 'src/Redux/wise-process/recipientApi'
import { useCurrenciesQuery } from 'src/Redux/wise-process/wiseCurrenciesApi'
import { useAppDispatch, useAppSelector } from 'src/Hooks/redux'
import { useGetRequirements } from 'src/Redux/wise-process/api-actions'
import { getRequirements } from 'src/Redux/wise-process/selectors'
import { setRequirementsToInitialState } from 'src/Redux/wise-process'

import { setCurrenciesOptions } from '../helpers'

import {
  SelectCurrency,
  FormGroupField,
  FormDescription,
  Form,
  FormGroup,
} from './styles'

interface CurrencyFormProps {
  setCurrentCurrency: (value: string) => void
}

export const CurrencyForm: FC<CurrencyFormProps> = (props) => {
  const { setCurrentCurrency } = props
  const requirements = useAppSelector(getRequirements)
  const hasRequirements = requirements.length > 0
  const dispatch = useAppDispatch()
  const currencies = useCurrenciesQuery()
  const recipient = useRecipientQuery()
  const [value, setValue] = useState<string | undefined>(
    () => recipient?.currency,
  )
  const [prevCurrency, setPrevCurrency] = useState(recipient?.currency)
  const getRequirementsData = useGetRequirements()

  if (prevCurrency !== recipient?.currency) {
    setPrevCurrency(recipient?.currency)
    if (recipient?.currency) {
      setValue(recipient.currency)
    }
  }

  const handleChangeCurrency = async (val: string): Promise<void> => {
    setValue(val)
    setCurrentCurrency(val)
    dispatch(setRequirementsToInitialState())
    void dispatch(getRequirementsData(val))
  }
  return (
    <Form>
      <FormDescription>
        Select the currency you would like your payout to be. We recommend
        selecting your local currency.
      </FormDescription>
      <SelectCurrency>
        <FormGroup>
          <FormGroupField>
            <PrimarySelect
              showSearch
              value={value}
              options={setCurrenciesOptions(currencies)}
              placeholder='Select currency'
              label='Currency'
              onChange={handleChangeCurrency}
              filterOption={(input, option) =>
                (option?.label?.toString() ?? '')
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
            />
          </FormGroupField>
        </FormGroup>
        <WiseLogo height={56} width={117} />
      </SelectCurrency>
      {hasRequirements && (
        <FormDescription>
          In order to comply with our local tax regulations, we are required to
          have full detailed information about all users who are getting payouts
          from us.
        </FormDescription>
      )}
    </Form>
  )
}
